import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ExportarArchivoBancoRequest } from '@models/comprobantes/exportarArchivoBanco.model';
import {
  ExclusionExportacionDto,
  TransferenciaPreviaDto,
  ValidarExportacionBancoResponse
} from '@models/comprobantes/validarExportacionBanco.model';
import { ComprobantesService } from '@services/comprobantes/comprobantes.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';

/**
 * Confirmación previa a exportar el archivo del banco.
 *
 * El archivo mueve plata real y una vez importado en el homebanking no hay
 * vuelta atrás, así que el usuario tiene que ver antes: a qué banco va, desde
 * qué cuenta sale, quién cobra, cuánto, y sobre todo QUIÉN QUEDA AFUERA.
 *
 * Lo que quedaba afuera era invisible: el back exportaba y devolvía un número
 * de excluidos sin decir quiénes. Ahora se listan uno por uno con el motivo.
 */
@Component({
  selector: 'app-dialog-exportacion-banco',
  templateUrl: './dialog-exportacion-banco.component.html',
  styleUrls: ['./dialog-exportacion-banco.component.css']
})
export class DialogExportacionBancoComponent implements OnInit {

  validacion: ValidarExportacionBancoResponse = new ValidarExportacionBancoResponse();
  cargando: boolean = true;
  exportando: boolean = false;

  dataSourceTransferencias = new MatTableDataSource<TransferenciaPreviaDto>();
  dataSourceExcluidos = new MatTableDataSource<ExclusionExportacionDto>();

  columnasTransferencias: string[] = ['propietario', 'cbu', 'liquidaciones', 'importe'];
  columnasExcluidos: string[] = ['propietario', 'motivo', 'liquidaciones', 'importe'];

  constructor(
    public dialogRef: MatDialogRef<DialogExportacionBancoComponent>,
    @Inject(MAT_DIALOG_DATA) public request: ExportarArchivoBancoRequest,
    private comprobantesService: ComprobantesService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.validar();
  }

  //#region Chequeo

  validar() {
    this.cargando = true;
    this.spinner.show("spExportacionBanco");

    this.comprobantesService.validarExportacionBanco(this.request).subscribe(
      data => {
        this.cargando = false;
        this.spinner.hide("spExportacionBanco");

        this.validacion = isFalsy(data) ? new ValidarExportacionBancoResponse() : data;
        this.dataSourceTransferencias.data = this.validacion.transferencias ?? [];
        this.dataSourceExcluidos.data = this.validacion.excluidos ?? [];
      },
      error => {
        this.cargando = false;
        this.spinner.hide("spExportacionBanco");
        this.snackBar.showError(error, "Error");
        this.cerrar();
      }
    );
  }

  hayExcluidos(): boolean {
    return this.dataSourceExcluidos.data.length > 0;
  }

  /** Los corregibles son los que se arreglan cargando un dato, no cambiando el contrato */
  hayCorregibles(): boolean {
    return this.dataSourceExcluidos.data.some(e => e.esCorregible);
  }

  /**
   * El CBU se muestra parcial a propósito: alcanza para reconocer la cuenta sin
   * dejar el número completo a la vista de cualquiera que mire la pantalla.
   */
  cbuParcial(cbu: string): string {
    if (isFalsy(cbu))
      return "";

    return cbu.length <= 8 ? cbu : `${cbu.substring(0, 4)}••••${cbu.substring(cbu.length - 4)}`;
  }

  //#endregion

  /** Devuelve true: la pantalla que abrió el diálogo genera el archivo */
  confirmar() {
    if (!this.validacion.puedeExportar)
      return;

    this.dialogRef.close({ event: AccionesDialog.Aceptar });
  }

  cerrar() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  trackByItems(index: number, item: any): any { return index; }
}
